module.exports = __webpack_public_path__ + "static/media/origen.23e31d48.svg";